let process_actions = (actions) => {
    for (const action of actions) {
        const data = window.Smart.utils.process_action_data(action.data)

        window.Smart.actions[action.name](data)
    }
}

export default process_actions;
